/**
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { c as createSVGComponent } from '../utils-9450cd75.js';
import '@carbon/icon-helpers';
import 'vue';

const ChevronUp24 = createSVGComponent('ChevronUp24', {
  "xmlns": "http://www.w3.org/2000/svg",
  "viewBox": "0 0 32 32",
  "fill": "currentColor",
  "width": 24,
  "height": 24
}, [{
  "elem": "path",
  "attrs": {
    "d": "M16 10L26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z"
  }
}]);

export { ChevronUp24 as default };
